// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"s3qI958s"};
    if(module.hot) {
      // 1764331278621
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  